import styled from '@emotion/styled';

import { IconButton as _IconButton } from '@hrworks/sui-core/IconButton';
import { Select as _Select } from '@hrworks/sui-core/Select';
import { TextField as _TextField } from '@hrworks/sui-core/TextField';

import { mq } from '../../util/mediaQueries';
import { Button } from '../Button';

const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.stellenportal?.style?.backgroundColor || theme.eclipseTier2Color.surface.base,
  border: `1px solid ${theme.eclipseTier2Color.border.bold}`,
  borderRadius: theme.eclipseTier1.radius['8px'],
  padding: theme.eclipseTier1.spacing['20px'],
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.eclipseTier1.spacing['20px'],
  marginBlock: theme.eclipseTier1.spacing['20px'],
  zIndex: 1,
}));

const InputContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  gap: theme.eclipseTier1.spacing['16px'],
  width: 'min(510px, 100%)',
  margin: 'auto',
}));

const TextField = styled(_TextField)({
  flex: 1,
});

// Auf kleinen Viewports zeigen wir statt des Text-Buttons den IconButton – beide sind im DOM,
// die Umschaltung passiert per Media-Query (kein Hydration-Mismatch beim SSR).
const SubmitButton = styled(Button)({
  [mq['<=xs']]: { display: 'none' },
});

const SubmitIconButton = styled(_IconButton)(({ theme }) => ({
  backgroundColor: theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.background.brand.bold.default,
  color: theme.stellenportal?.buttonStyle?.fontStyle?.color || theme.eclipseTier2Color.text.inverse,
  flexShrink: 0,
  alignSelf: 'center',
  [mq.supportsHover]: {
    '&&:hover': {
      opacity: theme.variables.opacity.high,
    },
  },
  [mq['>=sm']]: { display: 'none' },
}));

const SectionContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const ResetButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-end',
  color: theme.stellenportal?.fontStyle?.color,
}));

const Select = styled(_Select)({
  '& [role="listbox"]': { color: 'initial' },
});

export const S = {
  Container,
  InputContainer,
  TextField,
  SubmitButton,
  SubmitIconButton,
  SectionContainer,
  ResetButton,
  Select,
} as const;
